function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import { useAccentColors } from '../../hooks';
import { Body, CallToAction, Heading, Label } from '../../atoms';
import ReactConfigContext from '../../ReactConfigContext';
export default function BadgeCard(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? 'row' : _param_variant, label = param.label, title = param.title, action = param.action, metadata = param.metadata, secondaryAction = param.secondaryAction, metaActions = param.metaActions, badge = param.badge, accentColor = param.accentColor, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    var accentStyle = useAccentColors([
        'colors-badge-row-card-accent',
        accentColor
    ]);
    return /*#__PURE__*/ React.createElement("article", {
        style: accentStyle,
        className: twMerge(variant === 'standalone' && 'pt-[3rem] sm:pt-0', className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge('block rounded-xl bg-bg-subtle', action.className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === 'row' && 'sm:grid sm:items-center sm:grid-cols-[auto_minmax(0px,1fr)_auto]')
    }, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === 'row' && 'sm:pl-6', variant === 'standalone' && 'px-6 pt-6 flex justify-center h-[4.975rem] sm:flex-col sm:mt-0 sm:h-auto')
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge('block bg-badge-row-card-accent text-fg-inverted text-center p-6', variant === 'row' && 'rounded-t-xl sm:rounded-xl', variant === 'standalone' && 'rounded-xl mt-[-4.5rem] sm:mt-0', action.className)
    }), !!badge.title && /*#__PURE__*/ React.createElement("div", {
        className: "font-heading text-heading-h2-desktop font-semibold leading-tight"
    }, badge.title), !!badge.label && /*#__PURE__*/ React.createElement(Body, {
        className: "font-semibold uppercase"
    }, badge.label))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge('p-6', variant === 'standalone' && 'text-center sm:text-left')
    }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        className: twMerge('grid grid-cols-1 grid-flow-row auto-rows-max gap-4 md:gap-3', action.className)
    }), !!label && /*#__PURE__*/ React.createElement(Label, null, label), !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: variant === 'row' ? 'h4' : 'h3'
    }, title), !!(metadata === null || metadata === void 0 ? void 0 : metadata.length) && /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-max gap-3"
    }, metadata.map(function(entry) {
        return /*#__PURE__*/ React.createElement("div", {
            key: "entry-".concat(entry.title),
            className: twMerge('grid items-start gap-4 grid-flow-row auto-rows-max', variant === 'row' && 'grid-cols-[auto_1fr]', variant === 'standalone' && 'grid-cols-1 justify-items-center text-center sm:justify-items-start sm:grid-cols-[auto_1fr] sm:text-left')
        }, /*#__PURE__*/ React.createElement("div", {
            className: "text-badge-row-card-accent mt-2"
        }, entry.icon), /*#__PURE__*/ React.createElement("div", null, entry.title));
    }))), (metaActions === null || metaActions === void 0 ? void 0 : metaActions.length) && /*#__PURE__*/ React.createElement("div", {
        className: "mt-3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-start items-center flex-wrap -mx-3 -my-1"
    }, metaActions.map(function(metaAction) {
        return /*#__PURE__*/ React.createElement(Body, {
            key: metaAction.action.href,
            className: "mx-3 my-1"
        }, /*#__PURE__*/ React.createElement("span", null, metaAction.label), /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, metaAction.action), {
            className: twMerge('font-semibold text-badge-row-card-accent', metaAction.action.className)
        }), metaAction.action.label));
    })))), !!secondaryAction && /*#__PURE__*/ React.createElement("div", {
        className: twMerge('w-full', variant === 'row' && 'px-6 pb-6 sm:pl-0 sm:pb-0 md:mt-6 md:mb-auto', variant === 'standalone' && 'px-6 pb-6')
    }, /*#__PURE__*/ React.createElement(CallToAction, _object_spread_props(_object_spread({}, secondaryAction), {
        variant: "button/border",
        className: twMerge('flex flex-col w-full', secondaryAction.className)
    }))))));
}

//# sourceMappingURL=BadgeCard.js.map